import { useNavigate } from '@tanstack/react-router'
import { memo, useCallback } from 'react'
import Button from '~components/ui/button'
import getRootPath from '~utils/app/get-root-path'
import resourceUriDecorate, { RequiredWidth } from '~utils/resource-uri-decorator'

const NotFound404 = memo(() => {
  const navigate = useNavigate()
  const onGoToHomeClick = useCallback(() => {
    navigate({
      to: getRootPath() ?? '/',
      replace: true,
      resetScroll: true,
    })
  }, [navigate])

  return (
    <main className="flex flex-1 flex-col items-center justify-center h-full px-5 flex-gap-y-2">
      <img
        className="mb-4"
        src={resourceUriDecorate(`${import.meta.env.VITE_STATIC_RES}/img/error_dog.webp`, {
          width: RequiredWidth.W240,
        })}
        alt="404"
        width={138}
        height={130}
      />
      <h1 className="text-primary-600 text-headline-3 text-center">{`Oops! Looks like this page got lost in the chew toy`}</h1>
      <p className="text-primary-600 text-body-2 text-center">{`Sorry, we can't find the page you're looking for.\n
Let's get you back on track.`}</p>
      <section className="flex flex-col flex-gap-y-2 mt-6">
        <Button onClick={onGoToHomeClick}>Go to Home</Button>
      </section>
    </main>
  )
})

NotFound404.displayName = 'NotFound404'

export default NotFound404
